// Setup: wie oft die Seite aufgerufen wurde (je Laden einmal gezählt, ohne Adressen oder Cookies, siehe Visits.java).
import { h, type VNode } from 'snabbdom';
import { call } from '../api';
import { t } from '../i18n';

interface Stats {
  today: number;
  week: number;
  total: number;
  since: string | null;
}

let stats: Stats | null = null;
let asked = false;

/** einmal je Laden der Seite nachfragen; Zahlen ändern sich ohnehin nur beim nächsten Aufruf */
export function visitsBox(redraw: () => void): VNode {
  if (!asked) {
    asked = true;
    void call<Stats>('GET', '/api/visits').then(s => ((stats = s), redraw()), () => {});
  }
  const num = (n: number) => n.toLocaleString(document.documentElement.lang || 'de');
  const since = stats?.since ? new Date(stats.since).toLocaleDateString(document.documentElement.lang || 'de') : null;
  return h('div.setup', [
    h('div.hd', h('h3', t('Aufrufe'))),
    h('div.fld', stats ? [
      h('div.row', [h('span', t('Heute')), h('span', num(stats.today))]),
      h('div.row', [h('span', t('Letzte 7 Tage')), h('span', num(stats.week))]),
      h('div.row', [h('span', since ? t('Gesamt seit {d}', { d: since }) : t('Gesamt')), h('span', num(stats.total))]),
      h('p.muted.small', t('Gezählt wird jedes Laden der Seite auf diesem Server, ohne Adressen oder Cookies. Testläufe und Suchmaschinen zählen nicht.')),
    ] : [h('p.muted.small', t('Wird geladen …'))]),
  ]);
}
